import React, { useState, useEffect } from 'react';
import './ProjectsSearch.css';

function ProjectsSearch() {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setIsExpanded(true);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Initial check

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="searchFilterWrapper">
      {isMobile && (
        <div className="searchHeader" onClick={() => setIsExpanded(!isExpanded)}>
          <p className="searchFilter">What are you searching for here?</p>
          <button className="collapseButton">
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              width="24" 
              height="24" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
              className={isExpanded ? 'expanded' : ''}
            >
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </button>
        </div>
      )}
      <div className={`wrapperSearch ${isExpanded ? 'expanded' : ''}`}>
        <input type="search" name="" placeholder="Search project name..." id="" />
        <select name="region" id="" placeholder="Select Region">
          <option value="">Select Region</option>
          <option value="">Select Project</option>
          <option value="">Select Project</option>
          <option value="">Select Project</option>
        </select>
        <select name="stage" id="" placeholder="Select Stage">
          <option value="">Select Stage</option>
          <option value="">Select Project</option>
          <option value="">Select Project</option>
          <option value="">Select Project</option>
        </select>
        <select className="mineralType" name="mineralType">
          <option value="">Select Mineral</option>
          <option value="platinum">Platinum</option>
          <option value="gold">Gold</option>
          <option value="copper">Copper</option>
          <option value="nickel">Nickel</option>
          <option value="diamond">Diamond</option>
          <option value="coal">Coal</option>
        </select>
        <button className="searchButton">
          <span className="searchIconWrapper">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="black"/>
              <path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="black"/>
              <path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="black"/>
            </svg>
          </span>
        </button>
      </div>
    </div>
  );
}

export default ProjectsSearch; 